import { createContext } from "react";

const DF_OT0018Context = createContext();

export { DF_OT0018Context };